var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ListItem, ListItemText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useRecordContext, useTranslate } from 'react-admin';
import classnames from 'classnames';
import { EventAvatar } from '../EventAvatar';
import { useEventLabel } from '../useEventLabel';
/**
 * Default component to display an audit logs.
 * @see Timeline
 */
export var RecordTimelineItem = function (props) {
    var className = props.className, classesOverride = props.classes, rest = __rest(props, ["className", "classes"]);
    var classes = useStyles(props);
    var translate = useTranslate();
    var record = useRecordContext(props.record);
    var actionLabel = useEventLabel({ record: record, variant: 'record' });
    if (!record) {
        return null;
    }
    return (React.createElement(ListItem, __assign({ className: classnames(classes.root, className), button: false, dense: true, disableGutters: true }, rest),
        React.createElement(ListItemText, { primary: React.createElement("div", { className: classes.authorContainer },
                React.createElement(EventAvatar, { className: classes.avatar, alt: record.author.fullName, src: record.author.avatar, fullName: record.author.fullName, role: "presentation", size: "small" }),
                React.createElement(Typography, { color: "textPrimary", className: classes.content },
                    React.createElement("strong", { className: classes.author }, record.author.fullName ||
                        translate("ra-audit-log.author", record.author)))), secondary: React.createElement("span", { className: classes.action }, actionLabel) })));
};
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    authorContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
    author: {},
    action: {},
    date: {},
}); }, {
    name: 'RaTimelineItem',
});
